/**
 * Der gewählte Mandant, über einen Neustart hinweg.
 *
 * Er steht im lokalen Speicher und nicht in der Adresse: das Backoffice wechselt den
 * Mandanten selten, und ein Link soll auf eine Buchung zeigen, nicht auf eine
 * Mandantenwahl. Durchgesetzt wird er ohnehin serverseitig — der Header darf nur
 * auswählen, was die Mitgliedschaft erlaubt.
 */
const KEY = "bookking.tenant";

export function readSelectedTenant(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    // Privater Modus oder blockierte Speicherung: dann gilt der erste Mandant.
    return null;
  }
}

export function writeSelectedTenant(tenant: string | null): void {
  try {
    if (tenant) {
      window.localStorage.setItem(KEY, tenant);
    } else {
      window.localStorage.removeItem(KEY);
    }
  } catch {
    // Ohne Speicher bleibt die Wahl auf diese Sitzung beschränkt.
  }
}

/**
 * Die Rolle, die ein interner Admin eingenommen hat. Nur zusammen mit dem Mandanten
 * sinnvoll und nur auf Testsystemen wirksam; für alle anderen übergeht der Server den
 * Header (IdentityService.assumedRole).
 */
const ROLE_KEY = "bookking.role";

export function readAssumedRole(): string | null {
  try {
    return window.localStorage.getItem(ROLE_KEY);
  } catch {
    return null;
  }
}

export function writeAssumedRole(role: string | null): void {
  try {
    if (role) {
      window.localStorage.setItem(ROLE_KEY, role);
    } else {
      window.localStorage.removeItem(ROLE_KEY);
    }
  } catch {
    // Ohne Speicher bleibt die Wahl auf diese Sitzung beschränkt.
  }
}
